import 'luminate/src/main'
import './extensions/toggler'
import Init from './init'

import FloatLabel from './modules/float-label'
import FormValidator from './modules/form-validator'
import Sticky from './modules/sticky'
import ScrollMarker from './modules/scroll-marker'
import Swiper from './modules/swiper'
import Lightbox from './modules/lightbox'
import Map from './modules/map'
import Parallax from './modules/parallax'
import ScrollFader from './modules/scroll-fader'
import Notification from './modules/notification'

Lum.register(FloatLabel)
Lum.register(FormValidator)
Lum.register(Sticky)
Lum.register(ScrollMarker)
Lum.register(Swiper)
Lum.register(Lightbox)
Lum.register(Map)
Lum.register(Parallax)
Lum.register(ScrollFader)
Lum.register(Notification)

Init()



/** WEBPACK FOOTER **
 ** ./source/scripts/main.js
 **/